import { createReducer } from 'reduxsauce';
import actions from './actions';

const { Types } = actions;
const INITIAL_STATE = {
  isRequesting: false,
  billing: null,
  newOlsbilling: null,
  primaryCardDetails: {},
  ispaymentLoading: false,
  isPaymentSuccess: false,
  paymentDetails: {},
  error: null,
  url: null,
  cardInfo: null,
  isPrimaryCardFailed: false,
  isCardLoading: false,
  creditCardInfo: {},
};

const request = (state = INITIAL_STATE) => {
  return {
    ...state,
    isRequesting: true,
    error: null,
  };
};

const makePaymentRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    ispaymentLoading: true,
    error: null,
  };
};

const loadBillingSuccess = (state = INITIAL_STATE, { billing }) => {
  return {
    ...state,
    isRequesting: false,
    billing,
  };
};

const loadNewOlsBillingSuccess = (state = INITIAL_STATE, { newOlsbilling }) => {
  return {
    ...state,
    isRequesting: false,
    newOlsbilling,
  };
};

const loadPrimaryCardRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    isRequesting: true,
    isPrimaryCardFailed: false,
    error: null,
  };
};

const loadPrimaryCardSuccess = (state = INITIAL_STATE, { primaryCardDetails }) => {
  return {
    ...state,
    isRequesting: false,
    isPrimaryCardFailed: false,
    primaryCardDetails,
  };
};

const loadPrimaryCardFailure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    isRequesting: false,
    billing: null,
    isPrimaryCardFailed: true,
    error,
  };
};

const makePrimarySuccess = (state = INITIAL_STATE) => {
  return {
    ...state,
    isRequesting: true,
  };
};
const makePaymentSuccess = (state = INITIAL_STATE, { paymentDetails }) => {
  return {
    ...state,
    ispaymentLoading: false,
    isPaymentSuccess: true,
    paymentDetails,
  };
};

const addNewCardSuccess = (state = INITIAL_STATE) => {
  return {
    ...state,
    isRequesting: true,
  };
};

const saveCardInfoSuccess = (state = INITIAL_STATE, { cardInfo }) => {
  return {
    ...state,
    isRequesting: false,
    cardInfo,
  };
};

const deleteCardSuccess = (state = INITIAL_STATE) => {
  return {
    ...state,
    isRequesting: true,
  };
};

const loadBillingUrlSuccess = (state = INITIAL_STATE, { url }) => {
  return {
    ...state,
    isRequesting: false,
    url,
  };
};

const failure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    isRequesting: false,
    billing: null,
    error,
  };
};

const makePaymentFailure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    ispaymentLoading: false,
    isPaymentSuccess: false,
    billing: null,
    error,
  };
};

const paymentReset = (state = INITIAL_STATE) => {
  return {
    ...state,
    isPaymentSuccess: false,
    paymentDetails: {},
  };
};

const addCreditCardRequest = (state = INITIAL_STATE) => {
  return {
    ...state,
    isCardLoading: true,
    creditCardInfo: {},
    error: null,
  };
};

const addCreditCardSuccess = (state = INITIAL_STATE, { creditCardInfo }) => {
  return {
    ...state,
    isCardLoading: false,
    creditCardInfo,
  };
};

const addCreditCardFailure = (state = INITIAL_STATE, { error }) => {
  return {
    ...state,
    isCardLoading: false,
    creditCardInfo: {},
    error,
  };
};

export const HANDLERS = {
  [Types.LOAD_BILLING_REQUEST]: request,
  [Types.LOAD_BILLING_SUCCESS]: loadBillingSuccess,
  [Types.LOAD_BILLING_FAILURE]: failure,

  [Types.LOAD_NEW_OLS_BILLING_REQUEST]: request,
  [Types.LOAD_NEW_OLS_BILLING_SUCCESS]: loadNewOlsBillingSuccess,
  [Types.LOAD_NEW_OLS_BILLING_FAILURE]: failure,

  [Types.LOAD_PRIMARY_CARD_REQUEST]: loadPrimaryCardRequest,
  [Types.LOAD_PRIMARY_CARD_SUCCESS]: loadPrimaryCardSuccess,
  [Types.LOAD_PRIMARY_CARD_FAILURE]: loadPrimaryCardFailure,

  [Types.PAYMENT_RESET]: paymentReset,

  [Types.MAKE_PRIMARY_REQUEST]: request,
  [Types.MAKE_PRIMARY_SUCCESS]: makePrimarySuccess,
  [Types.MAKE_PRIMARY_FAILURE]: failure,

  [Types.MAKE_PAYMENT_REQUEST]: makePaymentRequest,
  [Types.MAKE_PAYMENT_SUCCESS]: makePaymentSuccess,
  [Types.MAKE_PAYMENT_FAILURE]: makePaymentFailure,

  [Types.ADD_NEW_CARD_REQUEST]: request,
  [Types.ADD_NEW_CARD_SUCCESS]: addNewCardSuccess,
  [Types.ADD_NEW_CARD_FAILURE]: failure,

  [Types.SAVE_CARD_INFO_REQUEST]: request,
  [Types.SAVE_CARD_INFO_SUCCESS]: saveCardInfoSuccess,
  [Types.SAVE_CARD_INFO_FAILURE]: failure,

  [Types.DELETE_CARD_REQUEST]: request,
  [Types.DELETE_CARD_SUCCESS]: deleteCardSuccess,
  [Types.DELETE_CARD_FAILURE]: failure,

  [Types.LOAD_BILLING_URL_REQUEST]: request,
  [Types.LOAD_BILLING_URL_SUCCESS]: loadBillingUrlSuccess,
  [Types.LOAD_BILLING_URL_FAILURE]: failure,

  [Types.ADD_CREDIT_CARD_REQUEST]: addCreditCardRequest,
  [Types.ADD_CREDIT_CARD_SUCCESS]: addCreditCardSuccess,
  [Types.ADD_CREDIT_CARD_FAILURE]: addCreditCardFailure,
};

export default createReducer(INITIAL_STATE, HANDLERS);
